import { Grid, PargodaRoundButton, styled } from '../../base';

export const ForgotPasswordButton = styled(PargodaRoundButton)(({ theme }) => ({
    minWidth: '210px',
    height: theme.spacing(6),
    background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 86.24%)`,
}));

export const ForgotPasswordFormWrapper = styled(Grid)(() => ({
    maxWidth: '510px',
    display: 'flex',
    alignSelf: 'center',
}));
